import React, {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';
import {TAlbum, TTrack} from '../../../typings/todo';
import {Cover} from '../../components/Cover';
import {ControlBarContainer} from '../ControlBarContainer';

export interface IOuter {
  album: TAlbum;
  track: TTrack | undefined;
  isNavigationButtonsHidden: boolean;
}

export const CoverContainer: FunctionComponent<IOuter> = ({album, track, isNavigationButtonsHidden}) => {
  const {t} = useTranslation();
  const isAlbum = !track;
  const cover = track && track.trackCover ? track.trackCover : album.albumCover;
  const entityName = isAlbum ? album.albumName : track.trackName;
  const coverAriaLabel = isAlbum
    ? t('mgw.aria.albumCover', {albumName: entityName})
    : t('mgw.aria.trackCover', {trackName: entityName});

  return (
    <Cover src={cover} accName={coverAriaLabel}>
      {album.tracks.length ? <ControlBarContainer isNavigationButtonsHidden={isNavigationButtonsHidden} /> : null}
    </Cover>
  );
};

CoverContainer.displayName = 'CoverContainer';
